var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config && _vm.config.editor && _vm.editor && _vm.editor.type && (_vm.editor.type == _vm.type || _vm.editor.type == _vm.type.split('-')[1]))?_c('div',{class:[
    'editor',
    {'selected': _vm.selected()}, 
    {'editor-row': _vm.params && _vm.params.cols && _vm.params.hook},
    {'editor-porlet': _vm.type === 'porlet'},
    {'editor-input': _vm.type === 'data'},
    {'editor-add': _vm.type.split('-')[0] === 'add'}
],on:{"click":function($event){return _vm.openEditor()}}},[_c('i',{class:[_vm.type.split('-')[0] === 'add' ? 'el-icon-plus' : 'el-icon-edit']})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }